import React, { useEffect, useRef, useState } from 'react'
import { load } from '@cashfreepayments/cashfree-js';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function CashfreeHD() {
    const hasCalled = useRef(false);
    let ORDER = ""
    const navigation = useNavigate()
    let cashfree;
    let initializeSDK = async function () {
        cashfree = await load({
            mode: "production"
            // mode: "sandbox"
        });
    };
    initializeSDK()

    const [orderId, setOrderId] = useState(null)

    useEffect(() => {
        if (hasCalled.current) return; // Prevent second call
        hasCalled.current = true;

        const params = new URL(window.location.href).searchParams;
        const userId = params.get("userid");
        const planId = params.get("plan_id");
        const deviceType = params.get("device_type");
        const deviceId = params.get("device_id");

        console.log("Parameters", userId, planId, deviceType, deviceId);
        if (userId && planId) {
            paymentInitiateCashfree(userId, planId, deviceType, deviceId);
        }

    }, [])

    const paymentInitiateCashfree = async (userId, planId, deviceType, deviceId) => {
        try {
            const resData = await axios.post('https://prmhd.thehnstore.com/api/payment_initiate/', {
                user_id: userId,
                plan: planId,
                device_type: deviceType,
                device_id: deviceId
            });
            if (resData?.data?.statuscode == 200) {
                let sessionId = await resData?.data?.data?.payment_session_id
                setOrderId(resData?.data?.data?.order_id)
                ORDER = resData?.data?.data?.order_id
                let checkoutOptions = {
                    paymentSessionId: sessionId,
                    redirectTarget: "_modal",
                }

                cashfree.checkout(checkoutOptions).then(async (result) => {
                    console.log("payment initialize", result)
                    const resData = await axios.post('https://prmhd.thehnstore.com/api/payment_verify/', { order_id: orderId || ORDER });
                    if (resData?.data?.status?.payment_status == "SUCCESS") {
                        navigation("/cfr-payment-success", { state: resData?.data, replace: true })
                    }
                    setOrderId(null);
                    ORDER = ""
                    console.log("verify status", resData)

                })



            }
            console.log("resData from api", resData);
        } catch (err) {
            console.error("Payment initiation error", err);
        }
    };

    return (
        <div>

        </div>
    )
}
